
const FT_INSPECTION_DOCUMENTS = "ft_inspection_documents"
const FT_INSPECTION_SIGNATURES = "ft_inspection_signatures"
const FT_RESOURCE_EVALUATION_FORM = "ft_resource_evaluation_form"
// Insights (epic #680). Evaluated server-side from PostHog and merged into the
// features payload, so it arrives with the authenticated response rather than
// through the PostHog browser SDK — analytics consent does not gate it.
const FT_INSIGHTS = "ft_insights"
// Agent access (MCP + REST under /api/agent), PostHog-managed like insights.
const FT_MCP = "ft_mcp"

const Features = Object.freeze({
  FT_INSPECTION_DOCUMENTS,
  FT_INSPECTION_SIGNATURES,
  FT_RESOURCE_EVALUATION_FORM,
  FT_INSIGHTS,
  FT_MCP
});

const FeaturesMap = Object.freeze({
  [Features.FT_INSPECTION_DOCUMENTS]: false,
  [Features.FT_INSPECTION_SIGNATURES]: false,
  [Features.FT_RESOURCE_EVALUATION_FORM]: false,
  [Features.FT_INSIGHTS]: false,
  [Features.FT_MCP]: false
});

export { FeaturesMap, Features };
